<template>
  <div class="row justify-content-between mx-4 mb-2">
    <div class="col-auto align-self-center">
      <button @click="backRoute()" v-if="$route.query.showReturn" class="btn">
        <i class="fa fa-long-arrow-alt-left"/> {{ $t('Back to search ') }}
      </button>
    </div>
    <div class="col-auto">
      <ol class="breadcrumb border-0 m-0">
        <li class="breadcrumb-item" v-for="(item, index) in lastRouteBreadcrubs" :key="index">
          <span class="active" v-if="index === lastRouteBreadcrubs.length - 1">{{ showName(item) }}</span>
          <router-link :to="item.path" v-else>{{ showName(item) }}</router-link>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
        props: {
            list: {
                type: Array,
                required: true,
                default: () => []
            }
        },
        computed: {
          lastRouteBreadcrubs() {
            const last = [...this.list].pop();
            const lastResolved = this.$router.resolve({
              name: last.name,
              params: this.$route.params,
           });

            return this.resolvePrevious(lastResolved.route);
          }
        },
        methods: {
            isLast (index) {
                return index === this.list.length - 1
            },
            showName (item) {
              //console.log(item)
                if (item.meta && item.meta.label) {
                    item = this.$t(item.meta.label)
                }
                if (item.name) {
                    item = this.$t(item.name)
                }
                return item
            },
            resolvePrevious(route) {
              if(_.has(route, 'meta.previous')) {
                let previous = this.$router.resolve({
                  name: route.meta.previous,
                  params: this.$route.params,
                });

                previous = {
                  ...previous.route,
                  name: previous.location.name,
                }

                if(_.has(previous, 'redirectedFrom')) {
                  const meta = previous.matched[0].meta;

                  previous = {
                    ...previous,
                    meta,
                  }
                } else if(_.has(previous, 'meta.previous')) {
                  const previousNested = this.resolvePrevious(previous);

                  return [...previousNested, route];
                }

                return [previous, route];
              }

              return [route];
            },
            backRoute(move = 1) {
              const length = window.history.length;

              if(length < move) {
                return;
              }

              const currentRoute = this.$route.fullPath;
              this.$router.go(-move);

              // If back doesn't work is a page refresh, back to 3 route to handle internal app redirects
              setTimeout(() => {
                this.$nextTick(() => {
                  if(currentRoute === this.$route.fullPath) {
                    this.backRoute(3)
                  }
                })
              },100);
            }
        }
}
</script>
